import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";

import { v4 as uuidv4 } from "uuid";

import CertificateModalWindow from "./ModalWindow/CertificateModalWindow";
import BasicDataCertificate from "./basicDataCertificate/BasicDataCertificate";
import AddressAndDocInfo from "./addressAndDocInfo/AddressAndDocInfo";
import CertificateInfo from "./certificateInfo/CertificateInfo";
import useChapterActionIdMatch from "../../../hooks/useChapterActionIdMatch";
import RevokeConfirmationModal from "./revokeConfirmationModal/RevokeConfirmationModal";

import {
  fieldsBasicDataCertificate,
  setupOptionsBasicDataCertificateByCertificateType,
} from "./basicDataCertificate/optionsBasicDataCertificate";

import {
  fieldsAddressDocCertificate,
  setDocOptionsDocumentsFromDictionaries,
  setupOptionsAddressCertificateByCertificateType,
} from "./addressAndDocInfo/optionsAddressAndDocInfo";
import {
  fieldsCertificateInfoCertificate,
  setupOptionsCertificateInfoByCertificateType,
} from "./certificateInfo/optionsCertificateInfo";

import {
  getLicenseById,
  addNewSpecialMark,
  revokeLicense,
  clearLicenseInfo,
} from "../../../redux/certificateReducer/actionsCertificate";

import { ProgressBar } from "react-loader-spinner";

import {
  boatDrivingLicenseSpecmarksList,
  tableLossOfControl,
  tableCertificateWithdrawal,
} from "./tableOptions";

import styles from "./Certificate.module.css";
import { fetchWithToken } from "../../../interceptors/fetchInterceptor";
import {
  API_EDIT_LICENSE_CARD,
  API_LICENSE_CANCELLATION,
  MAIN_URL,
  PORT,
} from "../../../constants/constants";
import ResultModalWindow from "../../AdministrativeProcedures/commonComponents/ResultModalWindow/ResultModalWindow";

export default function Certificate() {
  const {
    register,
    handleSubmit,
    control,
    watch,
    formState: { errors },
    setValue,
    clearErrors,
    setError,
    getValues,
    trigger,
  } = useForm({ mode: "onChange" });

  const id = window.location.pathname.split("/").at(-1);
  // const mode = window.location.pathname.includes("view") ? "view" : "edit";
  const currentDate = new Date().getTime();

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [generalOptions, setGeneralOptions] = useState({
    basicData: fieldsBasicDataCertificate,
    addressDocInfo: fieldsAddressDocCertificate,
    certificateInfo: fieldsCertificateInfoCertificate,
  });
  const [editMode, setEditMode] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showRevokeModal, setShowRevokeModal] = useState(false);
  const [modalWindowInputs, setModalWindowInputs] = useState(null);
  const [dataForEdit, setDataForEdit] = useState(null);
  const [type, setType] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [newData, setNewData] = useState({});
  const [tableLossOfControlCheck, setTableLossOfControlCheck] = useState(false);
  const [tableCertificateWithdrawalCheck, setTableCertificateWithdrawalCheck] = useState(false);
  const [isActive, setIsActive] = useState(true);
  const [showResultModal, setShowResultModal] = useState(false);
  const [registrationResult, setRegistrationResult] = useState("");
  const [appId, setAppId] = useState(null);
  const [errorText, setErrorText] = useState("");
  const [licenseConfStatus, setLicenseConfStatus] = useState(false);
  const [mode, setMode] = useState(window.location.pathname.includes("view") ? "view" : "edit");

  const licenseInfoFromState = useSelector((state) => {
    const { certificateReducer } = state;
    return certificateReducer.licenseInfo;
  });
  const sortedMenuNames = useSelector((state) => {
    const { roleControllerReducer } = state;
    return roleControllerReducer.sortedMenuNames;
  });
  const cancelCertificateAccess = useChapterActionIdMatch(
    sortedMenuNames?.CERTIFICATES?.cancelCertificate?.chapterActionId,
  );
  const addSpecMarkAccess = useChapterActionIdMatch(
    sortedMenuNames?.CERTIFICATES?.addASpecialNote?.chapterActionId,
  );
  const editSpecMarkAccess = useChapterActionIdMatch(
    sortedMenuNames?.CERTIFICATES?.editSpecialMark?.chapterActionId,
  );
  const addNotSeizureAccess = useChapterActionIdMatch(
    sortedMenuNames?.CERTIFICATES?.addANoteAboutTheSeizureOfTheId?.chapterActionId,
  );
  const addDrivingAccess = useChapterActionIdMatch(
    sortedMenuNames?.CERTIFICATES?.addANoteAboutDeprivationOfManagementRights?.chapterActionId,
  );
  const editHistoricalCardAccess = useChapterActionIdMatch(
    sortedMenuNames?.CERTIFICATES?.editRkHist?.chapterActionId,
  );

  const specMarkFromState = useSelector((state) => {
    const { certificateReducer } = state;
    return certificateReducer.licenseSpecmarksList;
  });

  const licenseConfFromState = useSelector((state) => {
    const { certificateReducer } = state;
    return certificateReducer.licenseConfList;
  });
  const dictionaryReducer = useSelector((state) => {
    const { dictionaryReducer } = state;
    return dictionaryReducer;
  });

  const resolveSubmit = async (data) => {
    const newStatement = { ...newData, ...data };
    newStatement.boatDrivingLicenseConfList = licenseConfFromState;
    newStatement.boatDrivingLicenseSpecmarksList = specMarkFromState;
    const request = await fetchWithToken(MAIN_URL + PORT + API_EDIT_LICENSE_CARD + id, {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=utf-8",
      },
      body: JSON.stringify(newStatement),
    });
    if (request.ok) {
      setShowResultModal(!showResultModal);
      setRegistrationResult("success");
    } else {
      setShowResultModal(!showResultModal);
      setRegistrationResult("error");
    }
  };

  const setOptionsFromLibs = () => {
    if (Object.values(dictionaryReducer.identificationDocuments).length > 0) {
      setDocOptionsDocumentsFromDictionaries(dictionaryReducer.identificationDocuments);
    }
  };
  const handleEditMode = () => {
    setEditMode(true);
  };

  const handleCloseButton = () => {
    dispatch(clearLicenseInfo());
    navigate("/certificates");
  };

  const handleAddNotes = (e) => {
    switch (e.currentTarget.id) {
      case "lossControl":
        setModalWindowInputs(tableLossOfControl);
        break;
      case "certificateWithdrawal":
        setModalWindowInputs(tableCertificateWithdrawal);
        break;
      case "boatDrivingLicenseSpecmarksList":
        setModalWindowInputs(boatDrivingLicenseSpecmarksList);
        break;
      default:
        break;
    }
    setType("save");
    setShowModal(true);
  };

  const handleEditNotes = (e) => {
    const data = specMarkFromState.find(
      (item) => item.id == e.currentTarget.id || item.innerId === e.currentTarget.id,
    );
    setType("edit");
    setModalWindowInputs(boatDrivingLicenseSpecmarksList);
    setDataForEdit(data);
    setShowModal(true);
  };

  const handleRevokeButton = () => {
    setShowRevokeModal(true);
  };

  const handleRevokeLicense = async () => {
    // const newData = {
    //   mark: "Удостоверение аннулировано",
    //   markDate: `${new Date().toISOString().slice(0, 10)} ${new Date().toISOString().slice(11, 23)}`,
    //   licenseId: licenseInfoFromState.licenseId,
    // };
    // dispatch(addNewSpecialMark(newData));
    const response = await fetchWithToken(
      MAIN_URL + PORT + API_LICENSE_CANCELLATION + licenseInfoFromState.licenseId,
      {
        method: "POST",
      },
    );
    const data = await response.text();
    if (!!data) {
      // dispatch(revokeLicense(data));
      handleEditMode();
      setMode("view");
      setIsActive(false);
      setShowRevokeModal(false);
      setRegistrationResult("success");
      setAppId("Refuse");
      setShowResultModal(true);
      dispatch(getLicenseById(id));
    } else {
      setRegistrationResult("error");
      setShowResultModal(true);
    }
  };

  useEffect(() => {
    const asyncWatch = async (value, { name, type }) => {
      if (type !== undefined) {
        if (newData[name] !== value[name]) {
          newData[name] = value[name];
        }
      }
    };
    const subscription = watch(asyncWatch);
    return () => subscription.unsubscribe();
  }, [watch]);

  useEffect(() => {
    dispatch(getLicenseById(id));
  }, []);

  useEffect(() => {
    if (Object.values(licenseInfoFromState).length > 0) {
      setGeneralOptions({
        ...generalOptions,
        basicData: setupOptionsBasicDataCertificateByCertificateType(licenseInfoFromState.licenseTypeId),
      });
      setGeneralOptions({
        ...generalOptions,
        addressDocInfo: setupOptionsAddressCertificateByCertificateType(licenseInfoFromState.licenseTypeId),
      });
      setGeneralOptions({
        ...generalOptions,
        certificateInfo: setupOptionsCertificateInfoByCertificateType(licenseInfoFromState.licenseTypeId),
      });
      for (let item in licenseInfoFromState) {
        setValue(item, licenseInfoFromState[item]);
        newData[item] = licenseInfoFromState[item];
      }
      setIsLoading(false);
    }
  }, [licenseInfoFromState]);

  useEffect(() => {
    setOptionsFromLibs();
  }, [dictionaryReducer]);

  useEffect(() => {
    setOptionsFromLibs();
  }, []);

  useEffect(() => {
    const index = licenseConfFromState.findIndex(
      (item) => item.confiscation.code === 1 && new Date(item.confDateEnd).getTime() > new Date().getTime(),
    );
    setTableLossOfControlCheck(index < 0 ? true : false);
    if (index >= 0) {
      const certificateWithdrawalList = licenseConfFromState.filter((item) => item.confiscation.code === 2);
      const certificateWithdrawalIndex = certificateWithdrawalList.findIndex(
        (item) => new Date(item.confDate) >= new Date(licenseConfFromState[index].confDate),
      );
      setTableCertificateWithdrawalCheck(certificateWithdrawalIndex < 0 ? true : false);
      setLicenseConfStatus(certificateWithdrawalIndex);
      // licenseConfFromState[index];
    }
  }, [licenseConfFromState]);

  return (
    <div className={styles.wrapper}>
      {isLoading ? (
        <div className="d-flex flex-column align-items-center">
          <ProgressBar
            height="80"
            width="80"
            ariaLabel="progress-bar-loading"
            borderColor="#D2AF8E"
            barColor="#BC8653"
          />
        </div>
      ) : (
        <>
          <h2 className={styles["main-text"]}>Удостоверение №{licenseInfoFromState.licenseNum}</h2>
          <form onSubmit={handleSubmit(resolveSubmit)}>
            <BasicDataCertificate
              inputData={licenseInfoFromState}
              fieldsOptions={generalOptions.basicData}
              register={register}
              newData={newData}
              control={control}
              setValue={setValue}
              mode={
                mode === "view"
                  ? "view"
                  : editHistoricalCardAccess && licenseInfoFromState.statusOfApp === 2
                  ? "edit"
                  : "view"
              }
              errors={errors}
              clearErrors={clearErrors}
              getValues={getValues}
              setError={setError}
            />
            <AddressAndDocInfo
              fieldsOptions={generalOptions.addressDocInfo}
              inputData={licenseInfoFromState}
              register={register}
              newData={newData}
              control={control}
              setValue={setValue}
              mode={
                mode === "view"
                  ? "view"
                  : editHistoricalCardAccess && licenseInfoFromState.statusOfApp === 2
                  ? "edit"
                  : "view"
              }
              errors={errors}
              clearErrors={clearErrors}
              // handleCustomButton={handleCustomButton}
              getValues={getValues}
              setError={setError}
            />
            <CertificateInfo
              inputData={licenseInfoFromState}
              fieldsOptions={generalOptions.certificateInfo}
              register={register}
              newData={newData}
              control={control}
              setValue={setValue}
              mode={
                mode === "view"
                  ? "view"
                  : editHistoricalCardAccess && licenseInfoFromState.statusOfApp === 2
                  ? "edit"
                  : "view"
              }
              errors={errors}
              clearErrors={clearErrors}
              // handleCustomButton={handleCustomButton}
              getValues={getValues}
              setError={setError}
            />
            <div>
              <h3 className={styles["second-main-text"]}>Отметки</h3>
              <div className={styles.block__data__container}>
                <div key={tableLossOfControl.keyTable}>
                  <p className={styles["container-description"]}>{tableLossOfControl.caption}</p>
                  {mode === "edit" &&
                    addDrivingAccess &&
                    tableLossOfControlCheck &&
                    licenseInfoFromState?.statusOfApp !== 0 && (
                      <div
                        className={`${styles["add-btn"]} ${mode === "edit" ? "" : styles.edit__mode}`}
                        id={tableLossOfControl.keyTable}
                        onClick={(e) => handleAddNotes(e)}>
                        <span className={styles["plus-icon"]}></span>
                        <span>{"Добавить"}</span>
                      </div>
                    )}
                  <table className={styles["table-container"]}>
                    <thead>
                      <tr>
                        {tableLossOfControl.nameColumn.map((item) => {
                          return <th id={item.key}>{item.value}</th>;
                        })}
                      </tr>
                    </thead>
                    <tbody>
                      {licenseConfFromState.map((elem) => {
                        if (elem.confiscation["code"] === 1) {
                          return (
                            <tr>
                              {tableLossOfControl.nameColumn.map((item) => {
                                if (item.key !== "confDate" && item.key !== "confDateEnd") {
                                  return (
                                    <td
                                      className={
                                        new Date(elem.confDateEnd).getTime() > currentDate
                                          ? styles.red_text
                                          : ""
                                      }>
                                      {elem[`${item.key}`]}
                                    </td>
                                  );
                                } else {
                                  return (
                                    <td
                                      className={
                                        new Date(elem.confDateEnd).getTime() > currentDate
                                          ? styles.red_text
                                          : ""
                                      }>
                                      {new Date(elem[`${item.key}`]).toLocaleDateString()}
                                    </td>
                                  );
                                }
                              })}
                            </tr>
                          );
                        }
                      })}
                    </tbody>
                  </table>
                </div>
                {licenseConfFromState.findIndex(
                  (item) =>
                    item.confiscation["code"] === 1 && new Date(item.confDateEnd).getTime() > currentDate,
                ) >= 0 && (
                  <div key={tableCertificateWithdrawal.keyTable}>
                    <p className={styles["container-description"]}>{tableCertificateWithdrawal.caption}</p>
                    {mode === "edit" &&
                      addNotSeizureAccess &&
                      !tableLossOfControlCheck &&
                      tableCertificateWithdrawalCheck &&
                      licenseInfoFromState?.statusOfApp !== 0 && (
                        <div
                          className={`${styles["add-btn"]} ${mode === "edit" ? "" : styles.edit__mode}`}
                          id={tableCertificateWithdrawal.keyTable}
                          onClick={(e) => handleAddNotes(e)}>
                          <span className={styles["plus-icon"]}></span>
                          <span>{"Добавить"}</span>
                        </div>
                      )}
                    <table className={styles["table-container"]}>
                      <thead>
                        <tr>
                          {tableCertificateWithdrawal.nameColumn.map((item) => {
                            return <th id={item.key}>{item.value}</th>;
                          })}
                        </tr>
                      </thead>
                      <tbody>
                        {licenseConfFromState.map((elem) => {
                          if (elem.confiscation["code"] === 2) {
                            return (
                              <tr>
                                {tableCertificateWithdrawal.nameColumn.map((item) => {
                                  switch (item.key) {
                                    case "userPositions":
                                      return (
                                        <td
                                          className={
                                            licenseConfFromState.indexOf(elem) === licenseConfStatus
                                              ? styles.red_text
                                              : ""
                                          }
                                          key={uuidv4()}>
                                          {elem.userid[`${item.key}`]["posName"]}
                                        </td>
                                      );
                                    case "userid":
                                      return (
                                        <td
                                          className={
                                            licenseConfFromState.indexOf(elem) === licenseConfStatus
                                              ? styles.red_text
                                              : ""
                                          }
                                          key={uuidv4()}>
                                          {elem.userid["name"]}
                                        </td>
                                      );
                                    case "confDate":
                                      return (
                                        <td
                                          className={
                                            licenseConfFromState.indexOf(elem) === licenseConfStatus
                                              ? styles.red_text
                                              : ""
                                          }
                                          key={uuidv4()}>
                                          {new Date(elem[`${item.key}`]).toLocaleDateString()}
                                        </td>
                                      );
                                    default:
                                      return (
                                        <td
                                          className={
                                            licenseConfFromState.indexOf(elem) === licenseConfStatus
                                              ? styles.red_text
                                              : ""
                                          }
                                          key={uuidv4()}>
                                          {elem[`${item.key}`]}
                                        </td>
                                      );
                                  }
                                })}
                              </tr>
                            );
                          }
                        })}
                      </tbody>
                    </table>
                  </div>
                )}

                <div key={boatDrivingLicenseSpecmarksList.keyTable}>
                  <p className={styles["container-description"]}>{boatDrivingLicenseSpecmarksList.caption}</p>
                  {mode === "edit" && addSpecMarkAccess && licenseInfoFromState?.statusOfApp !== 0 && (
                    <div
                      className={`${styles["add-btn"]} ${mode === "edit" ? "" : styles.edit__mode}`}
                      id={boatDrivingLicenseSpecmarksList.keyTable}
                      onClick={(e) => handleAddNotes(e)}>
                      <span className={styles["plus-icon"]}></span>
                      <span>{"Добавить"}</span>
                    </div>
                  )}
                  <table className={styles["table-container"]}>
                    <thead>
                      <tr>
                        {boatDrivingLicenseSpecmarksList.nameColumn.map((item) => {
                          return <th id={item.key}>{item.value}</th>;
                        })}
                        <th
                          key={uuidv4()}
                          className={`${mode === "edit" ? "" : styles.edit__mode} ${
                            styles.edit__column
                          }`}></th>
                      </tr>
                    </thead>
                    <tbody>
                      {specMarkFromState.map((elem) => {
                        return (
                          <tr>
                            {boatDrivingLicenseSpecmarksList.nameColumn.map((item) => {
                              if (item.key !== "markDate") {
                                return (
                                  <td
                                    className={
                                      elem.mark === "Удостоверение аннулировано" ? styles.red_text : ""
                                    }>
                                    {elem[`${item.key}`]}
                                  </td>
                                );
                              } else {
                                return (
                                  <td
                                    className={
                                      elem.mark === "Удостоверение аннулировано" ? styles.red_text : ""
                                    }>
                                    {new Date(elem[`${item.key}`]).toLocaleDateString()}
                                  </td>
                                );
                              }
                            })}
                            {mode === "edit" && (
                              <td
                                className={`${mode === "edit" ? "" : styles.edit__mode} ${
                                  styles.edit__column
                                }`}
                                key={uuidv4()}>
                                {editSpecMarkAccess &&
                                  elem.mark !== "Удостоверение аннулировано" &&
                                  licenseInfoFromState?.statusOfApp !== 0 && (
                                    <div
                                      className={`${styles["edit-button-block"]} ${
                                        mode === "edit" ? "" : styles.edit__mode
                                      }`}
                                      id={elem.id || elem.innerId}
                                      onClick={(e) => handleEditNotes(e)}>
                                      <span className={styles["edit-button"]}></span>
                                    </div>
                                  )}
                              </td>
                            )}
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div className={styles["buttons-block"]}>
              <div
                id="close"
                className={styles["close-btn"]}
                onClick={() => {
                  dispatch(clearLicenseInfo());
                  navigate("/certificates");
                }}>
                {"Закрыть"}
              </div>

              {Object.keys(licenseInfoFromState).length > 0 &&
                mode === "edit" &&
                cancelCertificateAccess &&
                !editMode &&
                licenseInfoFromState?.statusOfApp !== 0 && (
                  <div
                    id="decline"
                    className={styles["decline-btn"]}
                    onClick={() => handleRevokeButton()}>
                    {"Аннулировать"}
                  </div>
                )}
              {mode === "edit" && licenseInfoFromState?.statusOfApp !== 0 && (
                <button
                  id="save"
                  className={styles["save-btn"]}>
                  {"Сохранить"}
                </button>
              )}
            </div>
          </form>
          {showModal && (
            <CertificateModalWindow
              licenseIdModal={licenseInfoFromState.licenseId}
              setShowModal={setShowModal}
              showModal={showModal}
              modalWindowInputs={modalWindowInputs}
              dataForEdit={dataForEdit}
              setDataForEdit={setDataForEdit}
              type={type}
              setType={setType}
            />
          )}
          {showRevokeModal && (
            <RevokeConfirmationModal
              isOpen={showRevokeModal}
              title={"Подтвердите действие"}
              text={"Вы действительно хотите аннулировать удостоверение?"}
              textButton={"Подтвердить"}
              onClose={() => setShowRevokeModal(false)}
              onConfirm={handleRevokeLicense}
            />
          )}
          {showResultModal && (
            <ResultModalWindow
              appId={appId}
              show={showResultModal}
              setShow={setShowResultModal}
              result={registrationResult}
              handleCloseApp={handleCloseButton}
              errorText={errorText}
            />
          )}
        </>
      )}
    </div>
  );
}
